// extracted by mini-css-extract-plugin
export default {"panel":"Tickets_panel__iBQVv","work-button":"Tickets_work-button__MkKae"};